import { Component } from '@angular/core';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { ButtonComponent } from '../../utilities/button/button.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { InputComponent } from '../../utilities/input/input.component';
import { DropdownComponent } from '../../utilities/dropdown/dropdown.component';
import { ApiKeyService } from '../../services/api-key.service';
import { CommonModule } from '@angular/common';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CopyTextComponent } from "../../components/copy-text/copy-text.component";

@Component({
  selector: 'app-api-key',
  standalone: true,
  imports: [
    DashboardComponent,
    ButtonComponent,
    ModalComponent,
    InputComponent,
    DropdownComponent,
    CommonModule,
    CopyTextComponent
],
  templateUrl: './api-key.component.html',
  styleUrl: './api-key.component.scss',
})
export class ApiKeyComponent {
  addModalOpen: boolean = false;
  deleteModalOpen: boolean = false;
  loading: boolean = false;
  deleteId: string = '';
  fetchingData: boolean = false;
  newApiKey = {
    name: '',
    ipAddresses: [] as string[],
    expiresIn: '',
  };
  errors={
    name: '',
    expiresIn:''
  }
  durationOptions: any = [
    '1 Day',
    '1 Week',
    '1 Month',
    '1 Months',
    '6 Months',
    '1 Year',
  ];
  apiKeyCreated: boolean = false;
  generatedApiKey: string = '';
  apiKeys: any;

  constructor(private apiKeyService: ApiKeyService, private notification: NzNotificationService,){
    this.getApiKeys();
  }

  ngOnChanges() {
    this.apiKeyCreated = false;
    this.generatedApiKey = "";
  }
  removeSpaces(input: string): string {
    return input?.replace(/\s+/g, '');
  }
  separateByComma(input: string): string[] {
    return input.split(',').map(item => item.trim());
  }

  openAddModal() {
    this.addModalOpen = true;
  }
  openDeleteModal(id: string) {
    this.deleteModalOpen = true;
    this.deleteId = id;
  }
  closeDeleteModal() {
    this.deleteModalOpen = false;
  }
  closeAddModal() {
    this.addModalOpen = false;
  }
  setApiName = (value: string) => {
    this.newApiKey.name = value;
    if (value === '') {
      this.errors.name = 'Required*';
      return;
    } else {
      this.errors.name = '';
    }
  };
  setApiExpiry = (value: string) => {
    this.newApiKey.expiresIn = this.removeSpaces(value);
    if (value === '') {
      this.errors.expiresIn = 'Required*';
      return;
    } else {
      this.errors.expiresIn = '';
    }
  };
  setIpAddresses=(values: any)=>{
    this.newApiKey.ipAddresses = this.separateByComma(values);
  }
  validateForm = () => {
    const errors: any = {};
    if (this.newApiKey.name === '') {
      errors.name = 'Required*';
    }
    if (this.newApiKey.expiresIn === '') {
      errors.expiresIn = 'Required*';
    }
    console.log(errors);
    return errors;
  };

  getApiKeys() {
    this.fetchingData = true;
    this.apiKeyService.getApiKeys().subscribe({
      next: (res: any) => {
        console.log(res);
        this.apiKeys = res.data;
        this.fetchingData = false;
      },
      error: (err) => {
        this.fetchingData = false;
      },
    });
  }
  formatDate(date: string) {
    const dateTimeString = date;
    const dateTime = new Date(dateTimeString);
    return dateTime.toLocaleString();
  }

  createApiKey = () => {
    if (Object.keys(this.validateForm()).length > 0) {
      this.errors = { ...this.errors, ...this.validateForm() };
    } else {
      this.loading = true;
    this.apiKeyService.createApiKey(this.newApiKey).subscribe(
      (res: any) => {
        this.generatedApiKey = res.data.apiKey;
        this.getApiKeys();
        this.apiKeyCreated = true;
         this.notification.success(
          'Success',
          'Sign In Successful',
          { nzClass: 'notification' }
        );
         this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.notification.error(
          'Error',
          'Something went wrong',
          { nzClass: 'notification' }
        );
      }
    );}
  }



  deleteApi = () => {
    this.loading = true;
    this.apiKeyService.deleteApiKey(this.deleteId).subscribe({
      next: (res: any) => {
        this.deleteModalOpen = false;
        this.loading = false;
        this.notification.success(
          'Success',
          'API Key Deleted',
          { nzClass: 'notification' }
        );
        this.getApiKeys();
      },
      error: (err) => {
        console.log(err);
        this.deleteModalOpen = false;
        this.loading = false;
      },
    });
  }
}
